import { swSettings } from "app/common/services/swSettings";
import { defaultWebsiteState } from "pro-features/components/AutocompleteDigitalMarketing/AutocompleteDigitalMarketingHelper";
import { proNavigator } from "single-spa/react-app/ProNavigator";

export const createWebsiteUrl = (domain: string, pageName = defaultWebsiteState, params = {}) => {
    const stateObject = proNavigator.getState(pageName);
    const configId = proNavigator.getConfigId(stateObject);
    const websiteDefaultParams = swSettings.components[configId].defaultParams;

    return proNavigator.href(pageName, { ...websiteDefaultParams, ...params, key: domain, isWWW: "*" });
};
